import {createStore} from 'vuex'

export default createStore({
    state: {
        msisdn: undefined,
        user : undefined,
        isLoading: false,
    },
    getters: {},
    mutations: {
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
        },
        setUser(state, user) {
            state.user = user
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
    },
    actions: {},
    modules: {}
})
